<template>
  <div class="mobile full-width">
    <div class="header-mobile">
      <div class="mr-10 d-flex align-items-center">
        <div
          v-if="getToken().bank_id == SOURCE_BANK.BIDV"
          style="flex-shrink: 0; width:20px; "
          class="mr-10"
          @click="handleBack"
        >
          <img :src="icons.ArrowLeftIcon" alt="" />
        </div>
        <img
          :style="imageZise.mb"
          class="logo-wghn"
          :src="images.LogoWBooking"
          alt=""
        />
      </div>
      <div v-if="getToken().vga">
        <div class="d-flex align-center" @click="handleShowProfile">
          <span class="text-point c-text-main flex-shrink-0 mr-5">
            {{ convertLargeNumber($store.getters.point) }}</span
          >
          <el-avatar
            :style="{
              border:
                !getInfo()?.avatar && getToken().bank_id == SOURCE_BANK.BIDV
                  ? '0px'
                  : '1px solid #1B4684'
            }"
            class="flex-shrink-0 ml-5"
            :size="30"
            :src="getInfo()?.avatar || getImageBySource()"
            @error="errorHandler"
          >
            <img :src="getImageBySource()" />
          </el-avatar>
        </div>
      </div>
      <div v-else @click="handleShowProfile">
        <p class="m-0 c-text-main">{{ $t("login") }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { getToken, getInfo } from "@/utils/auth.js";
import UserIcon from "@/assets/img/iconV2/btn_user.svg";
import { getBackGround } from "@/utils/wapAuth";
import LogoWBooking from "@/assets/img/svg/logo-wbooking.svg";
import LogoVNA from "@/assets/img/svg/logo-vna.svg";
import { formatNumber, convertLargeNumber } from "@/utils/formatData";
import { SOURCE_BANK } from "../../constant/contant";
import ArrowLeftIcon from "@/assets/img/v3/img/arrow_left.png";
import {
  ACTION_BIDV,
  postMessageBidv,
  partner_id_bidv
} from "../../utils/helper";

export default {
  components: {},
  props: {
    objectData: {
      type: Object,
      default() {
        return {};
      }
    },
    logo: {
      default: require("@/assets/img/logo/W_Booking_white.png")
    }
  },
  data() {
    return {
      SOURCE_BANK: SOURCE_BANK,
      bg: getBackGround(),
      extraNavClasses: "",
      toggledClass: false,
      admin: getToken(),
      images: {
        LogoWBooking,
        DefaultAvatar:
          "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
      },
      imageZise: {
        mb: "height: 25px; width:auto;",
      },
      icons: {
        UserIcon,
        ArrowLeftIcon
      }
    };
  },
  created() {
    const bank = getToken()?.bank_id;

    switch (bank) {
      // case SOURCE_BANK.VIETIN:
      //   bg = "#005790";
      //   break;
      // case SOURCE_BANK.SCB:
      //   bg = "#2984ca";
      //   break;
      // case +SOURCE_BANK.BIDV:
      //   bg = "transparent";
      //   break;
      case +SOURCE_BANK.VNA:
        this.images.LogoWBooking = LogoVNA
        this.imageZise = {
          mb: "height: 32px; width:auto;",
        }
        break;
      default:
       
        break;
    }
  },
  computed: {},
  methods: {
    convertLargeNumber,
    formatNumber,
    getToken,
    getInfo,
    getImageBySource() {
      if (getToken().bank_id == SOURCE_BANK.BIDV) {
        return require("@/assets/img/v3/img/user_default_bidv.png");
      } else {
        return this.images.DefaultAvatar;
      }
    },
    handleBack() {
      const infoBack = {
        a: ACTION_BIDV.BACK_APP,
        p: partner_id_bidv
      };
      postMessageBidv(infoBack);
      // location.href = `/wap/bidv/redirect-app`;
    },

    handleShowProfile() {
      if (!getInfo()) {
        this.$store.dispatch("showLoginDialog");
        return;
      }
      this.$store.dispatch("setShowProfile", true);
    },

    errorHandler(event) {
      event.target.src = this.images.DefaultAvatar;
      return;
    },
    handleResize() {
      // Xử lý khi chiều rộng màn hình thay đổi
      const windowWidth = window.innerWidth;
      if (windowWidth <= 991) {
        this.extraNavClasses = "";
      } else {
        this.extraNavClasses = `md-white`;
      }
    }
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  }
};
</script>

<style scoped>
.avatar-container {
  border-radius: 100px;
  padding: 4px 5px 4px 1px;
}
.text-point {
  font-weight: 600;
  font-size: 12px;
  line-height: 14.08px;
  letter-spacing: 0%;
  text-align: center;
}

.mobile {
  display: none;
}
.pc {
  display: block;
}
.lang-mobile {
  background: v-bind("bg.c_header") !important ;
  display: none;
}
.md-list-item .md-list-item-content p {
  color: v-bind("bg.c_menu_header");
  font-weight: 500;
}

.white-color {
  color: v-bind("bg.c_menu_header");
}
@media (max-width: 991px) {
}
@media screen and (min-width: 0px) and (max-width: 980px) {
  .drive {
    height: 1px;
    width: 100%;
    background-color: #d7d7d7;
    margin-top: 10px;
    margin-bottom: 13px;
  }
  .title {
    color: black;
    font-weight: 600;
    font-size: 16px;
  }

  .header-mobile {
    display: flex !important;
    justify-content: space-between;
    align-items: center;
  }
  .header-mobile-bottom {
    display: flex !important;
    justify-content: flex-end;
    align-items: center;
    height: 20px !important;
  }
  .lang-mobile {
    background: #0000 !important ;
    display: block;
    padding-left: 25px;
  }
  .lang-pc {
    display: none;
  }
  .mobile {
    display: block;
  }
  .pc {
    display: none;
  }
}
</style>
